/**
 * Known in-app browsers: the webviews social apps open links in.
 *
 * Google refuses OAuth in embedded webviews (`disallowed_useragent`) and these
 * shells handle `window.open` inconsistently, so Apple and Google sign-in are
 * not offered there. Email and password still work, so nothing is lost by
 * hiding the two buttons, and a button that cannot finish is worse than none.
 *
 * Markers only, never a browser allow-list: an unknown UA keeps the buttons,
 * and a marker is added here when an app is found to embed a webview.
 * Case-sensitive, as the apps write them.
 */
const IN_APP_MARKERS: readonly RegExp[] = [
  /\bInstagram\b/,
  // Facebook and Messenger: FBAN/FBAV (iOS), FB_IAB/FB4A (Android), FBIOS.
  /\bFBAN\/|\bFBAV\/|\bFB_IAB\b|\bFB4A\b|\bFBIOS\b/,
  /\bMessengerForiOS\b|\bMessengerLiteForiOS\b/,
  // TikTok writes its old app names (musical_ly on iOS, trill on Android) and
  // ByteDance's webview marker.
  /\bmusical_ly_|\bAppName\/(?:musical_ly|trill)\b|\bBytedanceWebview\/|\bTikTok\b/,
  /\bSnapchat\b/,
  /\bLinkedInApp\b/,
  /\bPinterest\b/,
  /\bLine\/\d/,
  /\bMicroMessenger\//,
];

export function isKnownInAppBrowser(userAgent: string): boolean {
  return IN_APP_MARKERS.some((marker) => marker.test(userAgent));
}
